import { render, staticRenderFns } from "./EventosPasados.vue?vue&type=template&id=398840a7"
import script from "./EventosPasados.vue?vue&type=script&setup=true&lang=js"
export * from "./EventosPasados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports